//
import React from "react";
import SpinnetButton from "../Loading/SpinnerButton/SpinnetButton";
import { colors } from "../../propsType/Colors";

function ButtonGeneric({
  disable,
  funtion,
  text,
  bgButton,
  colorText,
  loading,
}) {
  return (
    <>
      {loading ? (
        <>
          <div
            className={`'hover:border-[#09101F] hover:text-[#09101F] bg-[${colors.darkBlue}] w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-all ease-linear 1s`}
          >
            {loading ? (
              <>
                <SpinnetButton />
              </>
            ) : (
              <>{text}</>
            )}
          </div>
        </>
      ) : (
        <>
          <button
            disabled={disable}
            onClick={funtion}
            type="submit"
            className={` ${
              disable
                ? " text-[#0000008a] bg-[#dfdfdf]"
                : `hover:border-[#09101F] hover:text-[#09101F] bg-[${colors.darkBlue}] hover:bg-white`
            } w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-all ease-linear 1s`}
          >
            {loading ? (
              <>
                <SpinnetButton />
              </>
            ) : (
              <>{text}</>
            )}
          </button>
        </>
      )}
    </>
  );
}

export default ButtonGeneric;
